// TODO: Re-import script appending helper from the '@flicent/fieldpulse-react-component-library-frontend'
//  when the version including it is released
const SCRIPT_LOADED_ATTRIBUTE: string = 'data-loaded';

export const appendScriptIfNotExistsAndWaitForLoad = async (id: string, src: string, isTypeModule?: boolean, integrity?: string): Promise<void> => {
  let script: HTMLScriptElement | null = document.getElementById(id) as HTMLScriptElement | null;
  let newScriptCreated: boolean = false;

  if (!script) {
    newScriptCreated = true;
    script = document.createElement('script');
    script.id = id;
    script.src = src;

    if (isTypeModule) {
      script.type = 'module';
    }

    if (integrity) {
      script.integrity = integrity;
      script.crossOrigin = 'anonymous';
    }
  }
  // If the script already exists and is loaded, return immediately
  if (script.hasAttribute(SCRIPT_LOADED_ATTRIBUTE)) {
    return;
  }

  await new Promise<void>((resolve, reject) => {
    script!.addEventListener('load', () => {
      script?.setAttribute(SCRIPT_LOADED_ATTRIBUTE, 'true');
      resolve();
    });
    script!.addEventListener('error', (error) => {
      reject(error);

      // Clean up the script tag if it was just created and failed to load, so we don't leave a broken script tag in the DOM
      // and can attempt to append it again if needed
      if (newScriptCreated) {
        document.head.removeChild(script!);
      }
    });

    // Append the script only if it was newly created
    if (newScriptCreated) {
      document.head.append(script!);
    }
  });
};
